export default "__VITE_ASSET__DWwEG$_0__"